import { FieldArray } from 'formik';
import { useSelector } from 'react-redux';
import { Card, CardSection } from '@lightspeed/flame/Card';
import { Box, Flex } from '@lightspeed/flame/Core';
import { Heading3, Text } from '@lightspeed/flame/Text';
import { Autocomplete } from '../fields';
import { Divider } from '@lightspeed/flame/Divider';
import { RowLoader } from '../custom/rowLoader';
import useConnectionMode from '../../hooks/useConnectionMode';
import { LabelRequired } from '../custom/LabelRequired';
import { useEffect } from 'react';
import DynamicFields from '../custom/DynamicFields';
import { IconDelete } from '@lightspeed/flame/Icon/Delete';
import amIVisible from '../../componentControl/registry';

export const TaxMapping = (props) => {

    const { formik } = props

    const { taxes, isTaxFetching, isPostingMethodChanged } = useSelector(state => state.dashboard)

    const [, swName] = useConnectionMode()

    useEffect(() => {
        if (isPostingMethodChanged) {
            formik.setFieldValue('taxes', taxes?.taxLabels)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isPostingMethodChanged, taxes])

    const { taxes: taxMapping } = formik?.values

    const isDynamic = amIVisible("dynamic tax rates")

    return (
        <Box padding="0.75rem">
            <Heading3 mb="0.375rem">{'Tax rates'}</Heading3>
            <Text color="gray-600" mb="1.125rem" size="small">
                All tax rates must be mapped to a tax code or a G/L account in {swName}. Ensure that Sales Tax is enabled in {swName}
            </Text>
            <FieldArray name="taxes">
                {
                    (array) => {
                        const width = `${100 / 2}%`
                        return (
                            <Card mt="1rem">
                                <>
                                    <CardSection>
                                        <Flex width={"100%"} mb=".6rem">
                                            <Box width={width} pl="0.8rem" pr="0.8rem">
                                                <Text fontWeight="bold">Tax Rate</Text>
                                            </Box>
                                            <Box width={width} pl="0.8rem" pr="0.8rem">
                                                <LabelRequired>
                                                    Tax Account
                                                </LabelRequired>
                                                <Text fontWeight="bold"></Text>
                                            </Box>
                                        </Flex>
                                        <Divider />
                                    </CardSection>
                                    {isTaxFetching ? <RowLoader /> :
                                        <>
                                            {
                                                taxMapping?.map((row, index) => {
                                                    return (
                                                        <CardSection>
                                                            <Flex alignItems={"center"} width={"100%"} mb=".5rem">
                                                                <Box alignItems={"center"} width={width} pl="0.8rem" pr="0.8rem">
                                                                    <Text>{row?.id}</Text>
                                                                </Box>
                                                                <Box width={width} pl="0.8rem" pr="0.8rem">
                                                                    <Autocomplete
                                                                        name={`taxes[${index}].account`}
                                                                        formik={formik}
                                                                        options={taxes?.taxAccounts}
                                                                        placeholder={"Select Tax Account"}
                                                                    />
                                                                </Box>
                                                                {(isDynamic && row?.id !== "Exempt - 0%") && <IconDelete
                                                                    color="danger"
                                                                    pointer="cursor"
                                                                    style={{ marginLeft: '0.75rem', pointer: 'cursor' }}
                                                                    onClick={() => {
                                                                        array.remove(index)
                                                                    }}
                                                                />}
                                                                {
                                                                    ((isDynamic && row?.id === "Exempt - 0%") && <div style={{ width: "1.7rem" }} />)
                                                                }
                                                            </Flex>
                                                            <Divider />
                                                        </CardSection>
                                                    )
                                                })
                                            }
                                            {isDynamic && <DynamicFields title={"Tax Rate"} labels={taxMapping} options={taxes?.taxAccounts} onFieldAdd={(id = '', account = '') => {
                                                formik.setFieldValue('taxes', [...taxMapping, { id, account }])
                                            }} />}
                                        </>}
                                </>
                            </Card>
                        )
                    }
                }
            </FieldArray>
        </Box>
    )
}